import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { displayValue, getDataValue, isBlank, latestEntry } from '../utils';

const Settings = {
  Name: 'Indicator',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'label', type: 'text', name: 'Label' },
      { id: 'dataId', type: 'text', name: 'Data path' },
      { id: 'trueLabel', type: 'text', name: 'True/on label', default: 'On' },
      { id: 'falseLabel', type: 'text', name: 'False/off label', default: 'Off' },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'Unknown' },
    ],
    grid: true,
  },
};

function chipMeta(value, userSettings) {
  if (isBlank(value)) return { label: userSettings.emptyText || 'Unknown', color: 'default' };

  if (typeof value === 'boolean') {
    return {
      label: value ? userSettings.trueLabel || 'On' : userSettings.falseLabel || 'Off',
      color: value ? 'success' : 'default',
    };
  }

  const text = String(value).toLowerCase();

  if (['true', 'on', 'online', 'ok', 'good', 'connected', 'active', 'running'].includes(text)) {
    return { label: displayValue(value), color: 'success' };
  }

  if (['false', 'off', 'offline', 'error', 'fault', 'failed', 'disconnected', 'inactive'].includes(text)) {
    return { label: displayValue(value), color: 'error' };
  }

  if (['warn', 'warning', 'low'].includes(text)) {
    return { label: displayValue(value), color: 'warning' };
  }

  return { label: displayValue(value), color: 'info' };
}

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const value = getDataValue(latestEntry(DeviceData), userSettings.dataId);
  const meta = chipMeta(value, userSettings);

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        {userSettings.label ? <Typography sx={{ fontWeight: 700 }}>{userSettings.label}</Typography> : null}
        <Chip size="small" label={meta.label} color={meta.color} />
      </Stack>
    </Box>
  );
};

export default {
  Settings,
  View,
};
